import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../models/api-response';
import { Organization } from '../../models/organization';

@Injectable({ providedIn: 'root' })
export class OrganizationsService {
  constructor(private http: HttpClient) { }

  getOrganizations(page: number, size: number, search: string): Observable<ApiResponse<Organization[]>> {
    let params = new HttpParams()
      .set('page', page)
      .set('size', size);

    if (search.trim()) {
      params = params.set('search', search.trim());
    }

    return this.http.get<ApiResponse<Organization[]>>(
      `${environment.apiBaseUrl}/admin/organizations`,
      { params }
    );
  }

  createOrganization(request: {
    name: string;
    contactEmail: string | null;
    contactPhone: string | null;
  }) {
    return this.http.post<ApiResponse<Organization>>(
      `${environment.apiBaseUrl}/admin/organizations`,
      request
    );
  }

  updateOrganization(
    id: string,
    request: {
      name: string;
      contactEmail: string | null;
      contactPhone: string | null;
    }
  ) {
    return this.http.put<ApiResponse<Organization>>(
      `${environment.apiBaseUrl}/admin/organizations/${id}`,
      request
    );
  }

  activateOrganization(id: string) {
    return this.http.post<ApiResponse<Organization>>(
      `${environment.apiBaseUrl}/admin/organizations/${id}/activate`,
      {}
    );
  }

  suspendOrganization(id: string) {
    return this.http.post<ApiResponse<Organization>>(
      `${environment.apiBaseUrl}/admin/organizations/${id}/suspend`,
      {}
    );
  }

  disableOrganization(id: string) {
    return this.http.post<ApiResponse<Organization>>(
      `${environment.apiBaseUrl}/admin/organizations/${id}/disable`,
      {}
    );
  }

  getOrganizationById(id: string) {
    return this.http.get<ApiResponse<Organization>>(
      `${environment.apiBaseUrl}/admin/organizations/${id}`
    );
  }
}